<i18n>
{
  "cl": {
    "messageFieldLength":"Debe tener al menos 3 caracteres",
    "emptyResult":"No se encontraron resultados",
    "serverError": "Ocurrió un error al comunicarse con el servidor",
    "operationField": "Operación",
    "idNumberField": "RUT",
    "emailField": "Email"
  },
  "pe": {
    "messageFieldLength":"Debe tener al menos 3 caracteres",
    "emptyResult":"No se encontraron resultados",
    "serverError": "Ocurrió un error al comunicarse con el servidor",
    "operationField": "Operación",
    "idNumberField": "DNI",
    "emailField": "Email"
  },
  "br": {
    "messageFieldLength":"Deve ter pelo menos 3 caracteres",
    "emptyResult":"Nenhum resultado encontrado",
    "serverError": "Ocorreu um erro durante a comunicação com o servidor",
    "operationField": "Operação",
    "idNumberField": "CEP",
    "emailField": "Email"
  }
}
</i18n>
<template>
  <b-autocomplete
    v-model="searchString"
    size="is-small"
    field="nameLastName"
    rounded
    :expanded="expanded"
    class="search-bar"
    icon="search"
    :data="entities"
    :placeholder="placeholder"
    :loading="isLoading"
    :append-to-body="true"
    @select="option => $emit('select', option)">
    <template slot-scope="props">
      <div class="results-list">
        <div
          v-for="(parsedOption, i) in parseOption(props.option)"
          :key="i"
          :class="parsedOption.divClass">
          <span
            v-for="(text, j) in parsedOption.texts"
            :key="j"
            :class="text.spanClass">
            {{ text.text }}
          </span>
        </div>
      </div>
    </template>
    <template #empty>{{ emptyMessage }}</template>
  </b-autocomplete>
</template>
<script>
import { valueToFormatted } from 'creditu-types/format';

export default {
  name: 'FindEntitiesInput',
  props: {
    placeholder: { type: String },
    expanded: { type: Boolean },
    finder: { type: Function },
    showDate: { type: String }
  },
  data() {
    return {
      emptyMessage: '',
      isLoading: false,
      searchString: '',
      entities: [],
      cancelFindEntities: null
    };
  },
  watch: {
    async searchString(newValue) {
      if (!newValue || newValue.length < 3) {
        this.emptyMessage = this.$t('messageFieldLength');
        this.entities = [];
        return;
      }
      if (this.isLoading) {
        this.cancelFindEntities('cancelled');
      }
      this.isLoading = true;
      try {
        this.entities = await this.finder(this.parseString(newValue), cancelFunction => {
          this.cancelFindEntities = cancelFunction;
        });
        this.emptyMessage = this.entities.length === 0 ? this.$t('emptyResult') : '';
      } catch (error) {
        if (error.message === 'cancelled') {
          this.emptyMessage = '';
          return;
        }
        this.emptyMessage = this.$t('serverError');
      }
      this.isLoading = false;
    }
  },
  methods: {
    parseString: string => ((string.includes('@')) ? string.toString() : string.toString().replace(/\./g, '')),
    parseOption(option) {
      const parsed = [];
      const client = option.client || option;
      const makeDiv = (texts, divClass = '') => ({ texts, divClass });
      if (option.companyOperationId) {
        parsed.push(makeDiv([{
          text: `${this.$t('operationField')}: ${option.companyOperationId}`,
          spanClass: ''
        }], 'results-item-header'));
      }
      if (client.name) {
        parsed.push(makeDiv([
          { text: client.name, spanClass: '' },
          { text: client.lastName, spanClass: '' }
        ], 'results-item-header'));
        parsed.push(makeDiv(client.lastName || ''));
      }
      if (client.idNumber || client.email) {
        const currentFields = [];
        if (client.idNumber) {
          const createdAt = this.showDate === 'true' && client.createdAt ? client.createdAt.split('.')[0].replace('T', ' ').substring(0, 16) : '';
          const formattedIdNumber = valueToFormatted('idNumber', this.$i18n.locale, client.idNumber);
          let text = '';
          const hasClientProperty = Object.prototype.hasOwnProperty.call(client, 'externalprovider');
          if (hasClientProperty) {
            const riskProviderTag = client.externalprovider[0] ? client.externalprovider[0] : '';
            text = createdAt ? `${this.$t('idNumberField')}: ${formattedIdNumber} / ${createdAt} ${riskProviderTag}` : `${this.$t('idNumberField')}: ${formattedIdNumber} ${riskProviderTag}`;
          } else {
            text = createdAt ? `${this.$t('idNumberField')}: ${formattedIdNumber} / ${createdAt}` : `${this.$t('idNumberField')}: ${formattedIdNumber} `;
          }
          currentFields.push({
            text,
            spanClass: 'small'
          });
        }
        if (client.email) {
          currentFields.push({
            text: `${this.$t('emailField')}: ${client.email}`,
            spanClass: 'small'
          });
        }
        parsed.push(makeDiv(currentFields, 'results-item-body'));
      }
      // agregar fecha para risk evaluation
      return parsed;
    }
  }
};
</script>
<style>
.search-bar input{
  box-shadow: none !important;
  background-color: #EFEFEF;
}

.results-list {
  display: flex;
  flex-flow: column wrap;
}
.results-list div {
  display: flex;
  flex-flow: row wrap;
  gap: 0.2rem;
}
.results-list .small {
  font-size: 0.875em
}

@media  (max-width: 660px) {
.search-bar input{
  max-width: 100%;
}
}
</style>
